import * as dataStore from './DataStore';
import {getTitleUi} from "data/TitleInfoSelector";
import LibraryNewsletter from '../models/LibraryNewsletter';

/**
 * @returns a Series object
 */
export function getLibraryNewsletters() {
	const newsletters = dataStore.getJsonData().FeatureContent.LibraryAwareNewsletter;
	const sourceId = getTitleUi(dataStore.getJsonData());

	let retval = [];

	if (newsletters) {
		const data = newsletters.newsletters;
		if (data != null && data.length > 0) {
			retval = data.map((newsletter) => {
				return new LibraryNewsletter(newsletter, newsletters.optInLink, sourceId);
			});
		}
	}

	return retval;
}



// WEBPACK FOOTER //
// ./src/data/LibraryNewslettersSelector.js